<template>
  <section style="position: relative">
    <div v-if="shows.length === 0" class="no-shows">
      <i class="far fa-clipboard"></i>
      <div class="now-shows-text">Nenhum evento cadastrado</div>
    </div>
    <div v-if="loading" class="loading-stage"><i class="fas fa-spinner loading"></i></div>
    <div v-show="shows.length > 0">
      <div v-if="show" class="dropdown">
        <div @click="openDrop = !openDrop" ref="selected" class="selected">
          <div class="calendar">
            <span>{{ getDay(show.date) }}</span>
            <span>{{ getMonthText(show.date) }}</span>
          </div>
          <div class="time-text">
            <span>{{ getHours(show.date) }}</span>
            <span>{{ getMinutes(show.date) }}</span>
          </div>
          <div class="data">
            <div class="main-data">{{ show.name }}</div>
            <div class="detail-data">{{ `${show.duration}min | ${show.type}` }}</div>
          </div>
          <div class="drop-action">
            <i class="fas fa-angle-down"></i>
          </div>
        </div>
        <div class="selection" :class="{ show : openDrop }" :style="`width: ${$refs.selected && $refs.selected.clientWidth || 0}px`">
          <form @submit.prevent class="form" style="position: relative; padding: 5px 10px">
            <input v-model="search" type="text" placeholder="Pesquisar..." style="width: 100%; box-sizing: border-box" />
            <i class="fas fa-search show-search"></i>
          </form>
          <div v-for="s in filteredShows" :key="s.id" @click="selectShow(s)" class="selection-item" :class="{ active : s.id === show.id }">
            <div class="calendar">
              <span>{{ getDay(s.date) }}</span>
              <span>{{ getMonthText(s.date) }}</span>
            </div>
            <div class="time-text">
              <span>{{ getHours(s.date) }}</span>
              <span>{{ getMinutes(s.date) }}</span>
            </div>
            <div class="data">
              <div class="main-data">{{ s.name }}</div>
              <div class="detail-data">{{ `${s.duration}min | ${s.type}` }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- Without Stage -->
      <div v-if="show && show.withoutStage">
        <div class="total-info" style="max-width: 300px; margin: 50px auto 20px">
          <div @click="num ? num-- : false" class="button-prices" style="background: #999"><i class="fas fa-minus"></i></div>
          <input v-model="num" type="number" step="1" min="0" class="input-prices" />
          <div @click="num++" class="button-prices" style="background: #999"><i class="fas fa-plus"></i></div>
          <button @click="sellWithoutStage" class="button-buy" style="margin: 0"><i class="fas fa-dollar-sign"></i><span>VENDER</span></button>
        </div>
        <table class="table-prices">
          <tr class="t-header">
            <th align="left">Ingresso</th>
            <th v-if="!merge" align="right">Vendidos</th>
            <th align="right" class="t-free">Disponíveis</th>
          </tr>
          <tr v-for="p in prices" :key="p.id">
            <td align="left">{{ p.ticketType }}</td>
            <td v-if="!merge" align="right">{{ p.paid }}</td>
            <td align="right">{{ p.free }}</td>
          </tr>
          <tr class="t-footer">
            <th align="left">Total</th>
            <th v-if="!merge" align="right">{{ sumPaid }}</th>
            <th align="right" class="t-free">{{ sumFree }}</th>
          </tr>
        </table>
        <div class="total-info" style="height: auto; max-width: 200px; margin: 20px auto">
          <div @click="$router.push(`/ticket/${show.id}/search/search`)" class="button-prices"><i class="fas fa-search"></i></div>
          <div @click="resend = true" class="button-prices" style="background: #999"><i class="fas fa-paper-plane"></i></div>
          <div @click="toggleMerge" class="button-prices" style="background: #999"><i class="fas" :class="merge ? 'fa-eye' : 'fa-eye-slash'"></i></div>
          <div @click="resetStage" class="button-prices"><i class="fas fa-sync-alt"></i></div>
        </div>
      </div>
      <!-- With Stage -->
      <div v-if="show && !show.withoutStage">
        <transition name="pop" mode="out-in">
          <div v-if="selected.length === 0 && bookedSelected.length === 0" key="total-info" class="total-info">
            <div v-if="!merge" class="total-info-item">
              <div class="bubble" style="background-image: linear-gradient(to bottom right, #560070, #8900b3)">{{ sumPaid }}</div>
              <div class="bubble-text">VENDIDOS</div>
            </div>
            <div v-if="!merge" class="total-info-item">
              <div class="bubble" style="background-image: linear-gradient(to bottom right, #777777, #999999)">{{ sumBook }}</div>
              <div class="bubble-text">RESERVADOS</div>
            </div>
            <div v-if="merge" class="total-info-item">
              <div class="bubble" style="background-image: linear-gradient(to bottom right, #777777, #999999)">{{ sumPaid + sumBook }}</div>
              <div class="bubble-text">OCUPADOS</div>
            </div>
            <div class="total-info-item">
              <div class="bubble" style="background-image: linear-gradient(to bottom right, #4caf50, #397b3c)">{{ sumFree }}</div>
              <div class="bubble-text">DISPONÍVEIS</div>
            </div>
          </div>
          <div v-if="selected.length > 0" key="button-new" class="button-group">
            <div class="button-seat"><i class="fas fa-chair"></i><span>{{ seatsSelected }}</span></div>
            <div
              v-if="show.withSection"
              @click="$router.push(`/ticket/${show.id}/${JSON.stringify(selected)}/paid`)"
              class="button-buy"
            >
              <i class="fas fa-dollar-sign"></i>
              <span>VENDER</span>
            </div>
            <div
              v-else
              @click="$router.push(`/ticket/${show.id}/${selected.join(',')}/paid`)"
              class="button-buy"
            >
              <i class="fas fa-dollar-sign"></i>
              <span>VENDER</span>
            </div>
            <div
              v-if="show.withSection"
              @click="$router.push(`/ticket/${show.id}/${JSON.stringify(selected)}/book`)"
              class="button-book"
            >
              <i class="fas fa-book"></i>
              <span>RESERVAR</span>
            </div>
            <div
              v-else
              @click="$router.push(`/ticket/${show.id}/${selected.join(',')}/book`)"
              class="button-book"
            >
              <i class="fas fa-book"></i>
              <span>RESERVAR</span>
            </div>
          </div>
          <div v-if="bookedSelected.length > 0 && !show.withSection" key="button-update" class="button-group">
            <div class="button-seat"><i class="fas fa-chair"></i><span>{{ bookSelected }}</span></div>
            <div @click="$router.push(`/ticket/${show.id}/${bookedSelected.map(x => x.id).join(',')}/update`)" class="button-buy"><i class="fas fa-dollar-sign"></i><span>VENDER</span></div>
            <div
              v-if="bookedSelected.find(x => x.status === 'book')"
              @click="cancelBooked"
              class="button-book"
            >
              <i class="fab fa-creative-commons-nc"></i>
              <span>CANCELAR RESERVA</span>
            </div>

            <div
              v-if="bookedSelected.find(x => x.status === 'blocked')"
              @click="freeChair"
              class="button-book"
            >
              <i class="fas fa-chair"></i>
              <span>Liberar assento</span>
            </div>
          </div>
          <div v-else-if="bookedSelected.length > 0 && show.withSection" key="button-update-2" class="button-group">
            <div class="button-seat"><i class="fas fa-chair"></i><span>{{ bookSelected }}</span></div>
            <div @click="$router.push(`/ticket/${show.id}/${JSON.stringify(bookedSelected)}/update`)" class="button-buy"><i class="fas fa-dollar-sign"></i><span>VENDER</span></div>
            <div
              v-if="bookedSelected.find(x => x.status === 'book')"
              @click="cancelBooked"
              class="button-book"
            >
              <i class="fab fa-creative-commons-nc"></i>
              <span>CANCELAR RESERVA</span>
            </div>

            <div
              v-if="bookedSelected.find(x => x.status === 'blocked')"
              @click="freeChair"
              class="button-book"
            >
              <i class="fas fa-chair"></i>
              <span>Liberar assento</span>
            </div>
          </div>
        </transition>

        <div
          class="form-group align-end online-selector"
          v-if="hasStages"
        >
          <Selector
            class="custom-selector"
            style="width: 200px"
            v-model="selectedStage"
            :options="stages.map(x => {
              return {
                text: x.name,
                value: x
              }
            })"
          />
        </div>

        <!-- <div class="stages" v-if="this.hasStages">
          <div v-for="(stage, i) in stages" :key="i">
            <button @click="selectStage(stage)">{{stage.name}}</button>
          </div>
        </div> -->

        <div ref="stage-container" class="stage-container">
          <div v-html="stage" id="stage" class="stage"></div>
          <div @click="$router.push(`/ticket/${show.id}/search/search`)" class="tickets-search"><i class="fas fa-search"></i></div>
          <div @click="resend = true" class="tickets-resend"><i class="fas fa-paper-plane"></i></div>
          <div @click="toggleMerge" class="tickets-merge"><i class="fas" :class="merge ? 'fa-eye' : 'fa-eye-slash'"></i></div>
          <select v-if="merge" v-model="ticketType" @change="updateStage" class="tickets-type">
            <option :value="null">Sem reserva</option>
            <option v-for="t in ticketTypes" :key="t" :value="t">{{ t }}</option>
          </select>
          <div @click="svgZoom.zoomIn()" class="svgZoomIn"><i class="fas fa-plus"></i></div>
          <div @click="resetStage" class="svgZoomReset"><i class="fas fa-sync-alt"></i></div>
          <div @click="svgZoom.zoomOut()" class="svgZoomOut"><i class="fas fa-minus"></i></div>
        </div>
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="0" height="0" style="display: block" >
        <defs>
          <linearGradient id="color-ticket-sell" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#560070"/>
            <stop offset="100%" stop-color="#8900b3"/>
          </linearGradient>
          <linearGradient id="color-ticket-available" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#4caf50"/>
            <stop offset="100%" stop-color="#397b3c"/>
          </linearGradient>
          <linearGradient id="color-ticket-book" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#777777"/>
            <stop offset="100%" stop-color="#aaaaaa"/>
          </linearGradient>
          <linearGradient id="color-ticket-selected" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#0071b3"/>
            <stop offset="100%" stop-color="#0098b3"/>
          </linearGradient>
        </defs>
      </svg>
      <Ticket v-if="showDate && seat" :show="showDate" :seat="seat" :type="type" />
      <TicketsResend v-if="resend" :show="show.id" :close="() => resend = false" />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import svgPanZoom from 'svg-pan-zoom/src/svg-pan-zoom.js'
import logger from '../../logger'
import { getForTickets, get as getShow } from '../api/showDate'
import { getStage } from '../api/business'
import { getAll as getTickets, removeBooked } from '../api/ticket'
import Ticket from './Ticket.vue'
import svgDragSelect from 'svg-drag-select'
import Selector from './Selector.vue'
import TicketsResend from './TicketsResend.vue'

export default {
  name: 'tickets',
  components: { Ticket, TicketsResend, Selector },
  props: ['showDate', 'seat', 'type'],
  data () {
    return {
      loading: true,
      search: '',
      show: null,
      shows: [],
      openDrop: false,
      stage: null,
      stageData: null,
      selected: [],
      tickets: [],
      sumPaid: 0,
      sumBook: 0,
      sumFree: 0,
      bookedSelected: [],
      svgZoom: null,
      svgSelect: null,
      merge: false,
      ticketType: null,
      prices: [],
      hasStages: false,
      selectedStage: null,
      stages: [
        {
          id: 'Piso_Inferior',
          name: 'Piso Inferior'
        },
        {
          id: 'Piso_superior',
          name: 'Piso Superior'
        }
      ],
      num: 0,
      resend: false
    }
  },
  watch: {
    async '$route' (value) {
      if (!value.params['showDate']) {
        this.updateStage()
      }
    },
    selectedStage (value) {
      this.selectStage(value)
    },
    async show (value) {
      this.ticketType = null
      this.updateStage()
    },
    num (val) {
      if (val > this.sumFree) this.num = this.sumFree
    }
  },
  computed: {
    ...mapState(['business', 'user']),
    filteredShows () {
      // return this.shows.filter(x => x.id !== this.show.id && Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
      return this.shows.filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    },
    ticketTypes () {
      return [...new Set(this.tickets.filter(x => x.status === 'book').map(x => x.ticketType))].sort()
    },
    seatsSelected () {
      const selected = this.show.withSection ? this.selected.map(x => x.id) : this.selected
      const tables = this.prices.filter(x => x.ticketType.substr(0, 5) === 'Mesa ').map(x => Number(x.ticketType.split(' ')[1]))
      return tables.length === 0 ? selected.join(', ') : selected.reduce((acc, cur, idx, src) => {
        if (tables.includes(src.filter(x => x.split('-')[0] === cur.split('-')[0]).length)) {
          if (!acc.includes(cur.split('-')[0])) acc.push(cur.split('-')[0])
        } else {
          acc.push(cur)
        }
        return acc
      }, []).join(', ')
    },
    bookSelected () {
      const selected = this.bookedSelected.map(x => x.seat)
      const tables = this.prices.filter(x => x.ticketType.substr(0, 5) === 'Mesa ').map(x => Number(x.ticketType.split(' ')[1]))
      return tables.length === 0 ? selected.join(', ') : selected.reduce((acc, cur, idx, src) => {
        if (tables.includes(src.filter(x => x.split('-')[0] === cur.split('-')[0]).length)) {
          if (!acc.includes(cur.split('-')[0])) acc.push(cur.split('-')[0])
        } else {
          acc.push(cur)
        }
        return acc
      }, []).join('-')
    }
  },
  async mounted () {
    try {
      // Shows
      this.shows = await getForTickets()
      if (this.shows.length > 0) {
        const { stage } = await getStage(this.business.id)
        this.selectedStage = this.stages[0]
        this.stageData = stage
        this.selectShow(this.shows[0])
      } else {
        this.loading = false
      }
    } catch (error) {
      logger.error(error, this)
    }
  },
  methods: {
    selectStage (stage) {
      this.selectedStage = stage
      this.stages.forEach(x => {
        if (stage !== x && document.getElementById(x.id)) {
          document.getElementById(x.id).style.display = 'none'
        } else if (stage === x && document.getElementById(x.id)) {
          document.getElementById(x.id).style.display = 'initial'
        }
      })
    },
    sellWithoutStage () {
      if (this.num) {
        const seats = Array.from(Array(this.num).keys()).map(x => ++x).join(',')
        this.$router.push(`/ticket/${this.show.id}/${seats}/paid`)
        this.num = 0
      }
    },
    toggleMerge () {
      this.merge = !this.merge
      this.updateStage()
    },
    async cancelBooked () {
      try {
        await removeBooked(this.bookedSelected.map(x => x.id))
        this.resetStage()
      } catch (error) {
        logger.error(error, this)
      }
    },
    async freeChair () {
      try {
        await removeBooked(this.bookedSelected.filter(x => x.status === 'blocked').map(x => x.id))
        this.resetStage()
      } catch (error) {
        logger.error(error, this)
      }
    },
    resetStage () {
      // this.$refs['stage-container'].style.height = `${window.innerHeight - (window.innerWidth > 768 ? 195 : 225)}px`
      // this.svgZoom.resetZoom()
      // this.svgZoom.resize()
      // this.svgZoom.center()
      // this.svgZoom.fit()
      // this.svgZoom.disablePan()
      this.updateStage()
    },
    isSelectedStage (x) {
      return x.parentNode.parentNode.parentNode.parentNode.id === this.selectedStage.id
    },
    async selectShow (show) {
      this.show = show
      this.openDrop = false
    },
    async updateStage () {
      this.loading = true
      try {
        this.stage = ''
        this.svgZoom = null
        this.svgSelect = null
        this.sumPaid = 0
        this.sumBook = 0
        this.sumFree = 0
        this.selected = []
        this.bookedSelected = []
        const colorSell = this.merge ? 'url(#color-ticket-book) #777777' : 'url(#color-ticket-sell) #560070'
        this.tickets = await getTickets(this.show.id)
        // Without stage
        if (this.show.withoutStage) {
          const data = await getShow(this.show.id)
          this.sumFree = this.business.capacity
          this.prices = data.prices.map(x => {
            x.amount = x.amount > 0 ? x.amount : 0
            x.paid = this.tickets.filter(y => y.showPrice === x.id).length
            x.free = x.amount === 0 ? this.sumFree : x.available
            this.sumPaid += x.paid
            this.sumFree -= x.paid
            return x
          })
          this.prices.forEach(x => {
            if (!x.ticketType.toUpperCase().startsWith('MEIA')) x.free = this.sumFree
            else {
              if (x.amount > 0) {
                if (x.available > this.sumFree) {
                  x.free = this.sumFree
                  x.available = this.sumFree
                }
              }
            }
          })
        // With stage
        } else {
          this.stage = this.stageData
          const data = await getShow(this.show.id)
          this.prices = data.prices
          this.$nextTick(() => {
            this.$refs['stage-container'].style.height = `${window.innerHeight - (window.innerWidth > 768 ? 195 : 245)}px`
            if (document.body.offsetWidth > 768) {
              this.svgZoom = svgPanZoom(document.getElementById('stage').querySelector('svg'), {
                dblClickZoomEnabled: false,
                preventMouseEventsDefault: false,
                minZoom: 1,
                panEnabled: false,
                onZoom () { this.enablePan() }
              })
              this.svgSelect = svgDragSelect({
                svg: document.getElementById('stage').querySelector('svg'),
                referenceElement: null,
                selector: 'intersection',
                onSelectionStart: ({ svg, pointerEvent, cancel }) => {
                  if (this.svgZoom.isPanEnabled()) {
                    cancel()
                  }
                  document.getElementsByTagName('body')[0].style.userSelect = 'none'
                },
                onSelectionEnd: ({ svg, pointerEvent, selectedElements }) => {
                  document.getElementsByTagName('body')[0].style.userSelect = 'auto'

                  const filterFunctions = {
                    hasStages: (x) => {
                      return (
                        this.isSelectedStage(x) && (x.tagName === 'circle' ||
                        x.id.startsWith('Cad') ||
                        (x.tagName === 'path' && x.id.length <= 10 && x.id.length >= 2 && x.id !== 'Palco'))
                      )
                    },
                    noStages: (x) => (
                      (
                        x.tagName === 'circle' || x.id.startsWith('Cad') ||
                        (x.tagName === 'path' && x.id.length <= 10 && x.id.length >= 2 && x.id !== 'Palco')
                      )
                    )
                  }
                  const elements = selectedElements.filter(x => filterFunctions[this.hasStages ? 'hasStages' : 'noStages'](x))

                  // const elements = selectedElements.filter(x => x.tagName === 'circle' || x.id.startsWith('Cad') || (x.tagName === 'path' && x.id.length <= 5 && x.id.length >= 2))
                  elements.forEach(e => {
                    const ticket = this.tickets.find(y => y.seat === e.id)
                    if (ticket && (ticket.status === 'paid' || ticket.status === 'pay')) {
                      if (elements.length === 1) {
                        this.$router.push(`/ticket/${this.show.id}/${ticket.id}/info`)
                      }
                    } else {
                      if (!this.show.withSection && this.selected.indexOf(e.id) > -1) {
                        this.selected = this.selected.filter(y => y !== e.id)
                        // e.style.fill = 'url(#color-ticket-available) #4caf50'
                        e.style.fill = e.getAttribute('data-fill')
                        if (e.parentElement.parentElement.getAttribute('data-name') === 'Table') {
                          const seats = Array.from(e.parentElement.parentElement.children).filter((y, i, a) => i < a.length - 1).map(x => x.children[0].id)
                          if (this.tickets.filter(y => seats.includes(y.seat)).length === 0 && this.prices.find(y => y.ticketType.substr(0, 5) === 'Mesa ' && y.ticketType.split(' ')[1] === String(seats.length))) {
                            e.parentElement.parentElement.children[e.parentElement.parentElement.children.length - 1].children[0].style.fill = e.getAttribute('data-fill')
                          }
                        }
                      } else if (this.show.withSection && this.selected.map(x => x.id).indexOf(e.id) > -1) {
                        this.selected = this.selected.filter(y => y.id !== e.id)
                        // e.style.fill = 'url(#color-ticket-available) #4caf50'
                        e.style.fill = e.getAttribute('data-fill')
                        if (e.parentElement.parentElement.getAttribute('data-name') === 'Table') {
                          const seats = Array.from(e.parentElement.parentElement.children).filter((y, i, a) => i < a.length - 1).map(x => x.children[0].id)
                          if (this.tickets.filter(y => seats.includes(y.seat)).length === 0 && this.prices.find(y => y.ticketType.substr(0, 5) === 'Mesa ' && y.ticketType.split(' ')[1] === String(seats.length))) {
                            e.parentElement.parentElement.children[e.parentElement.parentElement.children.length - 1].children[0].style.fill = e.getAttribute('data-fill')
                          }
                        }
                      } else if (ticket && this.bookedSelected.map(y => y.seat).indexOf(e.id) > -1) {
                        this.bookedSelected = this.bookedSelected.filter(y => y.seat !== e.id)
                        // e.style.fill = 'url(#color-ticket-book) #777777'
                        e.style.fill = e.getAttribute('data-fill')
                        if (e.parentElement.parentElement.getAttribute('data-name') === 'Table') {
                          const seats = Array.from(e.parentElement.parentElement.children).filter((y, i, a) => i < a.length - 1).map(x => x.children[0].id)
                          if (this.tickets.filter(y => seats.includes(y.seat)).length === 0 && this.prices.find(y => y.ticketType.substr(0, 5) === 'Mesa ' && y.ticketType.split(' ')[1] === String(seats.length))) {
                            e.parentElement.parentElement.children[e.parentElement.parentElement.children.length - 1].children[0].style.fill = e.getAttribute('data-fill')
                          }
                        }
                      } else {
                        if (ticket && this.selected.length > 0 && this.user.profile.indexOf('sellOnlyReserved') === -1) {
                          this.selected.forEach(y => { document.getElementById('stage').querySelector(`[id=${y}]`).style.fill = 'url(#color-ticket-available) #4caf50' })
                          this.selected = []
                          this.bookedSelected.push({ id: ticket.id, seat: ticket.seat })
                        } else if (!ticket && this.bookedSelected.length > 0 && this.user.profile.indexOf('sellOnlyReserved') === -1) {
                          this.bookedSelected.forEach(y => { document.getElementById('stage').querySelector(`[id=${y.seat}]`).style.fill = 'url(#color-ticket-book) #777777' })
                          this.bookedSelected = []
                          this.selected.push(e.id)
                        } else if (ticket && !this.show.withSection) {
                          this.bookedSelected.push({ id: ticket.id, seat: ticket.seat, status: ticket.status })
                        } else if (ticket && this.show.withSection) {
                          this.bookedSelected.push({ id: ticket.id, seat: ticket.seat, status: ticket.status, section: ticket.section })
                        } else if (this.user.profile.indexOf('sellOnlyReserved') === -1) {
                          if (this.show.withSection) {
                            this.selected.push({
                              id: e.id,
                              section: e.parentElement.parentElement.parentElement.id
                            })
                          } else this.selected.push(e.id)
                        } else return
                        e.style.fill = 'url(#color-ticket-selected) #0071b3'
                        // Mesa
                        if (e.parentElement.parentElement.getAttribute('data-name') === 'Table') {
                          const seats = Array.from(e.parentElement.parentElement.children).filter((y, i, a) => i < a.length - 1).map(x => x.children[0].id)
                          if (this.selected.filter(y => seats.includes(this.show.withSection ? y.id : y)).length === seats.length || this.bookedSelected.filter(y => seats.includes(y.seat)).length === seats.length) {
                            if (this.tickets.filter(y => seats.includes(y.seat)).length === 0 && this.prices.find(y => y.ticketType.substr(0, 5) === 'Mesa ' && y.ticketType.split(' ')[1] === String(seats.length))) {
                              e.parentElement.parentElement.children[e.parentElement.parentElement.children.length - 1].children[0].style.fill = 'url(#color-ticket-selected) #0071b3'
                            }
                          }
                        }
                      }
                    }
                  })

                  // Mesas
                  selectedElements.filter(x => x.tagName !== 'text' && x.parentElement && x.parentElement.id.substr(0, 4) === 'Mesa' && x.parentElement.parentElement && x.parentElement.parentElement.getAttribute('data-name') === 'Table').forEach(x => {
                    const group = x.parentElement.parentElement
                    const seatsG = Array.from(group.children).filter(y => y.id.substr(0, 7) === 'Assento')
                    const seats = seatsG.map(y => y.children[0])
                    const seatsId = seats.map(y => y.id)
                    if (!this.prices.find(y => y.ticketType.substr(0, 5) === 'Mesa ' && y.ticketType.split(' ')[1] === String(seats.length))) return false
                    if (seatsId.filter(x => elements.find(y => y.id === x)).length === seatsId.length) {
                      if (this.bookedSelected.filter(y => seatsId.includes(y.seat)).length > 0 || this.selected.filter(y => seatsId.includes(this.show.withSection ? y.id : y)).length > 0) {
                        group.children[group.children.length - 1].children[0].style.fill = 'url(#color-ticket-selected) #0071b3'
                      } else {
                        group.children[group.children.length - 1].children[0].style.fill = seats[0].getAttribute('data-fill')
                      }
                    } else if (this.tickets.filter(y => y.status === 'book' && seatsId.includes(y.seat)).length > 0 && this.selected.length === 0) {
                      if (this.bookedSelected.filter(y => seatsId.includes(y.seat)).length === seats.length) {
                        this.bookedSelected = this.bookedSelected.filter(y => !seatsId.includes(y.seat))
                        seats.forEach(y => {
                          y.style.fill = 'url(#color-ticket-book) #777777'
                        })
                        group.children[group.children.length - 1].children[0].style.fill = 'url(#color-ticket-book) #777777'
                      } else {
                        seats.forEach(y => {
                          const ticket = this.tickets.find(z => z.seat === y.id)
                          if (!this.bookedSelected.find(z => z.seat === y.id)) {
                            this.bookedSelected.push({ id: ticket.id, seat: ticket.seat, status: ticket.status, section: ticket.section })
                          }
                          y.style.fill = 'url(#color-ticket-selected) #0071b3'
                        })
                        group.children[group.children.length - 1].children[0].style.fill = 'url(#color-ticket-selected) #0071b3'
                      }
                    } else if (this.selected.filter(y => seatsId.includes(this.show.withSection ? y.id : y)).length === seats.length && this.bookedSelected.length === 0) {
                      if (this.show.withSection) {
                        this.selected = this.selected.filter(y => !seatsId.includes(y.id))
                      } else {
                        this.selected = this.selected.filter(y => !seatsId.includes(y))
                      }
                      seats.forEach(y => {
                        y.style.fill = 'url(#color-ticket-available) #4caf50'
                      })
                      group.children[group.children.length - 1].children[0].style.fill = 'url(#color-ticket-available) #4caf50'
                    } else if (this.tickets.filter(y => seatsId.includes(y.seat)).length === 0 && this.bookedSelected.length === 0) {
                      seats.forEach(y => {
                        if (!this.selected.find(z => y.id === (this.show.withSection ? z.id : z))) {
                          if (this.show.withSection) {
                            this.selected.push({
                              id: y.id,
                              section: y.parentElement.parentElement.parentElement.id
                            })
                          } else {
                            this.selected.push(y.id)
                          }
                        }
                        y.style.fill = 'url(#color-ticket-selected) #0071b3'
                      })
                      group.children[group.children.length - 1].children[0].style.fill = 'url(#color-ticket-selected) #0071b3'
                    }
                  })
                }
              })
            } else {
              const viewportmeta = document.querySelector('meta[name=viewport]')
              viewportmeta.setAttribute('content', 'width=device-width, user-scalable=yes, initial-scale=1, minimum-scale=1, maximum-scale=3')
              this.svgSelect = null
            }

            if (!this.show.withSection) {
              Array.from(document.getElementsByClassName('exibir')).forEach(x => {
                x.classList.add('esconder')
              })
            }
            document.getElementById('stage').querySelectorAll('g').forEach(x => {
              const ticket = this.tickets.find(y => y.seat === x.children[0].id)
              if (ticket && (ticket.status === 'paid' || ticket.status === 'pay')) {
                if (x.children[0].parentElement.querySelector('svg')) {
                  x.children[0].parentElement.querySelector('svg').style.display = 'none'
                  x.children[0].parentElement.querySelector('text').style.display = 'block'
                }
                x.children[0].style.fill = colorSell
                this.sumPaid = this.sumPaid + 1
              } else if (ticket && ticket.status === 'book' && ticket.special) {
                if (this.merge && ticket.ticketType === this.ticketType) {
                  x.children[0].style.fill = 'url(#color-ticket-available) #4caf50'
                  this.sumFree = this.sumFree + 1
                } else {
                  x.children[0].style.fill = 'url(#color-ticket-book) #777777'
                  this.sumBook = this.sumBook + 1
                }
              } else if (ticket) {
                if (x.children[0].parentElement.querySelector('svg')) {
                  x.children[0].parentElement.querySelector('svg').style.display = 'none'
                  x.children[0].parentElement.querySelector('text').style.display = 'block'
                }
                if (this.merge && ticket.ticketType === this.ticketType) {
                  x.children[0].style.fill = 'url(#color-ticket-available) #4caf50'
                  this.sumFree = this.sumFree + 1
                } else if (ticket.status === 'blocked') {
                  x.children[0].style.fill = '#d2d2d2'
                  x.children[1].textContent = 'X'
                } else {
                  x.children[0].style.fill = 'url(#color-ticket-book) #777777'
                  this.sumBook = this.sumBook + 1
                }
              } else {
                if (x.children[0].parentElement.querySelector('svg')) {
                  x.children[0].parentElement.querySelector('svg').style.display = 'none'
                  x.children[0].parentElement.querySelector('text').style.display = 'block'
                }
                if (this.merge && this.ticketType) {
                  x.children[0].style.fill = 'url(#color-ticket-book) #777777'
                  this.sumBook = this.sumBook + 1
                } else if ((x.children[0].id && x.children[0].tagName === 'circle') || (x.children[0].tagName === 'path' && x.children[0].id.length <= 10 && x.children[0].id.length >= 2)) {
                  x.children[0].style.fill = 'url(#color-ticket-available) #4caf50'
                  this.sumFree = this.sumFree + 1
                }
              }
              // x.style.color = x.style.fill
              x.children[0].setAttribute('data-fill', x.children[0].style.fill)
            })

            // Mesas
            document.getElementById('stage').querySelectorAll('[data-name=Table]').forEach(x => {
              const tablePath = x.children[x.children.length - 1].children[0]
              if (tablePath) {
                tablePath.style.fill = 'url(#color-ticket-available) #4caf50'
                const seats = Array.from(x.children).filter((y, i, a) => i < a.length - 1).map(x => x.children[0].id)
                const hasTable = !!this.prices.find(y => y.ticketType.substr(0, 5) === 'Mesa ' && y.ticketType.split(' ')[1] === String(seats.length))
                if (!hasTable) tablePath.style.fill = 'url(#color-ticket-book) #777777'
                else if (this.selected.filter(y => seats.includes(this.show.withSection ? y.id : y)).length === seats.length) tablePath.style.fill = 'url(#color-ticket-selected) #0071b3'
                else if (this.tickets.filter(y => seats.includes(y.seat) && y.status !== 'book').length > 0) tablePath.style.fill = 'url(#color-ticket-sell) #560070'
                else if (this.tickets.filter(y => seats.includes(y.seat) && y.status === 'book').length > 0) tablePath.style.fill = 'url(#color-ticket-book) #777777'
              }
            })
          })
        }
      } catch (error) {
        logger.error(error, this)
      }
      this.loading = false
      this.$nextTick(() => {
        this.hasStages = document.getElementsByClassName('hasStages').length > 0
        this.selectStage(this.selectedStage)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.button-group {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
}

.online-selector {
  height: 73px;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
}

/deep/ .selector {
  background-color: #cccccc;
  color: #595959;
  font-size: 0.8em;
  padding: 2.5px;
  .selector-option {
    color: #595959;
    padding: 7px;
  }
}

.button-buy {
  display: flex;
  align-items: center;
  color: #fff;
  border: none;
  border: 1px solid $primary-color;
  border-radius: 100px;
  // box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  font-size: 1em;
  font-weight: 500;
  height: 40px;
  padding: 0 15px;
  cursor: pointer;
  margin-right: 5px;
  &:focus {
    outline: 0;
  }
  i {
    margin-right: 7px;
    font-size: 1.2em;
  }
}

.button-book {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  color: $primary-color;
  border: 2px solid $primary-color;
  border-radius: 100px;
  // box-shadow: 0 0 3px $primary-color;
  background-color: #fff;
  font-size: 1em;
  font-weight: 500;
  height: 40px;
  width: 40px;
  // padding: 0 15px;
  cursor: pointer;
  margin-left: 5px;
  &:focus {
    outline: 0;
  }
  i {
    // margin-right: 7px;
    font-size: 1.2em;
  }
  span {
    display: none;
  }
}

.button-seat {
  display: flex;
  align-items: center;
  color: #fff;
  border: none;
  border: 1px solid #0071b3;
  border-radius: 100px;
  // box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  background-image: linear-gradient(to bottom right, #0071b3, #0098b3);
  font-size: 1em;
  font-weight: 500;
  min-height: 40px;
  width: auto;
  padding: 5px 15px;
  cursor: pointer;
  margin-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 80px;
  text-overflow: ellipsis;
  max-width: 120px;
  &:focus {
    outline: 0;
  }
  i {
    margin-right: 7px;
    font-size: 1.2em;
  }
}

.total-info {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin: 10px 0;

  .total-info-item {
    display: flex;
    align-items: center;
    height: 40px;

    .bubble {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      color: #fff;
      font-size: 1.2em;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .bubble-text {
      display: none;
      font-size: 1.1em;
      font-weight: 500;
      color: #999;
      margin-left: 10px;
    }
  }
}

.stage-container {
  position: relative;
  padding: 0 0 35px;
  min-height: 300px;
  .stage {
    width: 100%;
    height: 100%;
  }
}

.svgZoomIn {
  position: absolute;
  bottom: 0;
  right: 80px;
  background-color: #999;
  // background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  // box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  color: #fff;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.svgZoomReset {
  position: absolute;
  bottom: 0;
  right: 40px;
  // background-color: #999;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  // box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  color: #fff;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.svgZoomOut {
  position: absolute;
  bottom: 0;
  right: 0;
  // background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  background-color: #999;
  // box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  color: #fff;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.tickets-search {
  position: absolute;
  bottom: 0;
  left: 0;
  // background-color: #999;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  // box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  color: #fff;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.tickets-resend {
  position: absolute;
  bottom: 0;
  left: 40px;
  background-color: #999;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  color: #fff;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.tickets-merge {
  position: absolute;
  bottom: 0;
  left: 80px;
  background-color: #999;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  color: #fff;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.tickets-type {
  width: 140px;
  position: absolute;
  bottom: 0;
  left: 125px;
  box-sizing: border-box;
  resize: none;
  appearance: none;
  font-family: 'Roboto', sans-serif;
  font-size: 1em;
  border: 1px solid $secondary-color;
  border-radius: 5px;
  padding: 8px;
  min-width: 50px;
  margin-top: 3px;
  transition: border 0.5s;
  cursor: pointer;
  background: #fff url("data:image/svg+xml;charset=utf8,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%204%205'%3E%3Cpath%20fill='%23667189'%20d='M2%200L0%202h4zm0%205L0%203h4z'/%3E%3C/svg%3E") no-repeat right .35rem center / .4rem .5rem;
  &:focus {
    outline: none;
  }
}

.loading-stage {
  // background-color: rgba(255, 255, 255, 0.5);
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    font-size: 60px;
    color: $primary-color;
  }
}

@keyframes ticket-down {
  0% { transform: translateY(0) }
  50% { transform: translateY(5px) }
  100% { transform: translateY(0) }
}

.no-shows {
  background-color: #f7f8f9;
  color: #66758c;
  border-radius: 5px;
  padding: 20px 25px;
  max-width: 250px;
  margin: 50px auto;
  text-align: center;
  font-size: 1rem;

  i {
    font-size: 3rem;
    margin-bottom: 20px;
  }
}

.show-search {
  position: absolute;
  top: 15px;
  right: 15px;
  color: #999;
  font-size: 1.5em;
}

.table-prices {
  border: 0;
  border-spacing: 0;
  border-collapse: collapse;
  color: #333;
  min-width: 330px;
  margin: 30px auto;

  tr:nth-child(2n+1) {
    background-color: #e5e5e5;
  }

  th {
    background-color: #fff;
  }

  td, th {
    padding: 10px;
  }

  .t-header {
    th {
      color: $primary-color;
      border-bottom: 2px solid $primary-color;
      font-weight: 500;
    }
    .t-free {
      color: green;
      border-bottom: 2px solid green;
    }
  }

  // .t-footer > th {
  //   color: #fff;
  //   font-weight: 400;
  //   background-color: #555;
  // }

  .t-footer {
    th {
      color: $primary-color;
      border-top: 2px solid $primary-color;
      font-weight: 500;
    }
    .t-free {
      color: green;
      border-top: 2px solid green;
    }
  }
}

.button-prices {
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  // box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: #fff;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.input-prices {
  color: $primary-color;
  font-size: 14px;
  font-weight: 500;
  border: 2px solid $primary-color;
  border-radius: 100px;
  height: 34px;
  text-align: center;
  width: 70px;
  &:focus {
    outline: none;
  }
  &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
  .svgZoomIn, .svgZoomReset, .svgZoomOut {
    display: none;
  }

// Desktop
@media screen and (min-width: $desktop-width) {
  .svgZoomIn, .svgZoomReset, .svgZoomOut {
    display: flex;
  }
  .bubble-text {
    display: block !important;
  }
  .button-book {
    padding: 0 15px;
    width: auto;
    // flex: 1;
    i {
      margin-right: 7px;
    }
    span {
      display: inline-block;
    }
  }
  .button-seat {
    max-width: 30vw;
  }
}
</style>

<style lang="scss">
@import "../_asset/scss/_variables";

.esconder {
  display: none;
}
.stage {
  circle {
    cursor: pointer;
    &:hover {
      fill: #aaa;
    }
  }
}

.svg-drag-select-area-overlay {
  border: 1px solid $secondary-color;
  background-color: $hover-color;
}
</style>
